import React from 'react';
import './Card.css';

export interface WxbCardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}

export const WxbCard: React.FC<WxbCardProps> = ({ 
  className = '', 
  children, 
  noPadding = false,
  ...props 
}) => (
  <div className={`wxb-card ${noPadding ? 'wxb-card-no-padding' : ''} ${className}`} {...props}>
    {children}
  </div>
);
